<template>
  <div class="container">
    <audio src="static/img/music.mp3" id="audio" preload="auto" loop></audio>
    <table></table>
    <img src="../../static/img/map.png" class="mappic" alt="">
    <img src="../../static/img/juan.png" class="juanzhou" alt="">
    <!-- 下方说明图片 -->
    <img src="../../static/img/font/lasa.png" class="fontpic" v-show="num == 1" alt="">
    <img src="../../static/img/font/jiuquan.png" class="fontpic" v-show="num == 2" alt="">
    <img src="../../static/img/font/chuanganbianjie.png" class="fontpic" v-show="num == 3" alt="">
    <img src="../../static/img/font/zichang.png" class="fontpic" v-show="num == 4" alt="">
    <img src="../../static/img/font/yanan.png" class="fontpic" v-show="num == 5" alt="">
    <img src="../../static/img/font/zunyi.png" class="fontpic" v-show="num == 6" alt="">
    <img src="../../static/img/font/beijing.png" class="fontpic" v-show="num == 7" alt="">
    <img src="../../static/img/font/dandong.png" class="fontpic" v-show="num == 8" alt="">
    <img src="../../static/img/font/nanjing.png" class="fontpic" v-show="num == 9" alt="">
    <img src="../../static/img/font/wuhan.png" class="fontpic" v-show="num == 10" alt="">
    <img src="../../static/img/font/xiangganbianjie.png" class="fontpic" v-show="num == 11" alt="">
    <img src="../../static/img/font/guangzhou.png" class="fontpic" v-show="num == 12" alt="">
    <img src="../../static/img/font/aomen.png" class="fontpic" v-show="num == 13" alt="">
    <img src="../../static/img/font/xianggang.png" class="fontpic" v-show="num == 14" alt="">
    <img src="../../static/img/font/nanchang.png" class="fontpic" v-show="num == 15" alt="">
    <img src="../../static/img/font/jinggangshan.png" class="fontpic" v-show="num == 16" alt="">
    <img src="../../static/img/font/gutian.png" class="fontpic" v-show="num == 17" alt="">
    <img src="../../static/img/font/jiaxing.png" class="fontpic" v-show="num == 18" alt="">
    <img src="../../static/img/font/shanghai.png" class="fontpic" v-show="num == 19" alt="">
    <img src="../../static/img/jybn.png" class="picleft" alt="">
    <img src="../../static/img/db.png" class="middle" alt="">
    <!-- 地标 -->
    <img :src="place[0]" class="dibiao" :style="dibiao[0]" @click="num = 1;" alt="">
    <img :src="place[1]" class="dibiao" :style="dibiao[1]" @click="num = 2;" alt="" v-show="num == 2">
    <img :src="place[2]" class="dibiao" :style="dibiao[2]" @click="num = 3;" alt="">
    <img :src="place[3]" class="dibiao" :style="dibiao[3]" @click="num = 4;" alt="">
    <img :src="place[4]" class="dibiao" :style="dibiao[4]" @click="num = 5;" alt="">
    <img :src="place[5]" class="dibiao" :style="dibiao[5]" @click="num = 6;" alt="">
    <img :src="place[6]" class="dibiao" :style="dibiao[6]" @click="num = 7;" alt="">
    <img :src="place[7]" class="dibiao" :style="dibiao[7]" @click="num = 8;" alt="">
    <img :src="place[8]" class="dibiao" :style="dibiao[8]" @click="num = 9;" alt="">
    <img :src="place[9]" class="dibiao" :style="dibiao[9]" @click="num = 10;" alt="">
    <img :src="place[10]" class="dibiao" :style="dibiao[10]" @click="num = 11;" alt="">
    <img :src="place[11]" class="dibiao" :style="dibiao[11]" @click="num = 12;" alt="">
    <img :src="place[12]" class="dibiao" :style="dibiao[12]" @click="num = 13;" alt="">
    <img :src="place[13]" class="dibiao" :style="dibiao[13]" @click="num = 14;" alt="">
    <img :src="place[14]" class="dibiao" :style="dibiao[14]" @click="num = 15;" alt="">
    <img :src="place[15]" class="dibiao" :style="dibiao[15]" @click="num = 16;" alt="">
    <img :src="place[16]" class="dibiao" :style="dibiao[16]" @click="num = 17;" alt="">
    <img :src="place[17]" class="dibiao" :style="dibiao[17]" @click="num = 18;" alt="">
    <img :src="place[18]" class="dibiao" :style="dibiao[18]" @click="num = 19;" alt="">
    <!-- 选中 -->
    <img :src="placechoose[0]" class="dibiao" :style="dibiao[0]" alt="" v-show="num == 1" >
    <img :src="placechoose[1]" class="dibiao" :style="dibiao[1]" alt="" v-show="num == 2">
    <img :src="placechoose[2]" class="dibiao" :style="dibiao[2]" alt="" v-show="num == 3">
    <img :src="placechoose[3]" class="dibiao" :style="dibiao[3]" alt="" v-show="num == 4">
    <img :src="placechoose[4]" class="dibiao" :style="dibiao[4]" alt="" v-show="num == 5">
    <img :src="placechoose[5]" class="dibiao" :style="dibiao[5]" alt="" v-show="num == 6">
    <img :src="placechoose[6]" class="dibiao" :style="dibiao[6]" alt="" v-show="num == 7">
    <img :src="placechoose[7]" class="dibiao" :style="dibiao[7]" alt="" v-show="num == 8">
    <img :src="placechoose[8]" class="dibiao" :style="dibiao[8]" alt="" v-show="num == 9">
    <img :src="placechoose[9]" class="dibiao" :style="dibiao[9]" alt="" v-show="num == 10">
    <img :src="placechoose[10]" class="dibiao" :style="dibiao[10]" alt="" v-show="num == 11">
    <img :src="placechoose[11]" class="dibiao" :style="dibiao[11]" alt="" v-show="num == 12">
    <img :src="placechoose[12]" class="dibiao" :style="dibiao[12]" alt="" v-show="num == 13">
    <img :src="placechoose[13]" class="dibiao" :style="dibiao[13]" alt="" v-show="num == 14">
    <img :src="placechoose[14]" class="dibiao" :style="dibiao[14]" alt="" v-show="num == 15">
    <img :src="placechoose[15]" class="dibiao" :style="dibiao[15]" alt="" v-show="num == 16">
    <img :src="placechoose[16]" class="dibiao" :style="dibiao[16]" alt="" v-show="num == 17">
    <img :src="placechoose[17]" class="dibiao" :style="dibiao[17]" alt="" v-show="num == 18">
    <img :src="placechoose[18]" class="dibiao" :style="dibiao[18]" alt="" v-show="num == 19">
  </div>
</template>
<script>
export default {
  name:'mapcom',
  data() {
    return {
      num:18,
      place:[
        'static/img/grey/lasa.png',
        'static/img/grey/jiuquan.png',
        'static/img/grey/chuanganbianjie.png',
        'static/img/grey/zichang.png',
        'static/img/grey/yanan.png',
        'static/img/grey/zunyi.png',
        'static/img/grey/beijing.png',
        'static/img/grey/dandong.png',
        'static/img/grey/nanjing.png',
        'static/img/grey/wuhan.png',
        'static/img/grey/xiangganbianjie.png',
        'static/img/grey/guangzhou.png',
        'static/img/grey/aomen.png',
        'static/img/grey/xianggang.png',
        'static/img/grey/nanchang.png',
        'static/img/grey/jinggangshan.png',
        'static/img/grey/gutian.png',
        'static/img/grey/jiaxing.png',
        'static/img/grey/shanghai.png',
      ],
      placechoose:[
        'static/img/yellow/lasa.png',
        'static/img/yellow/jiuquan.png',
        'static/img/yellow/chuanganbianjie.png',
        'static/img/yellow/zichang.png',
        'static/img/yellow/yanan.png',
        'static/img/yellow/zunyi.png',
        'static/img/yellow/beijing.png',
        'static/img/yellow/dandong.png',
        'static/img/yellow/nanjing.png',
        'static/img/yellow/wuhan.png',
        'static/img/yellow/xiangganbianjie.png',
        'static/img/yellow/guangzhou.png',
        'static/img/yellow/aomen.png',
        'static/img/yellow/xianggang.png',
        'static/img/yellow/nanchang.png',
        'static/img/yellow/jinggangshan.png',
        'static/img/yellow/gutian.png',
        'static/img/yellow/jiaxing.png',
        'static/img/yellow/shanghai.png',
      ],
      dibiao:[
        {//拉萨
          width:'14vw',
          top:'45vw',
          left:'23vw',
        },{//酒泉
          width:'14vw',
          top:'24vw',
          left:'40vw',
        },{//川甘边界
          width:'14vw',
          top:'41vw',
          left:'45vw',
        },{//子长
          width:'11vw',
          top:'34vw',
          left:'56vw',
        },{//延安
          width:'9vw',
          top:'44vw',
          left:'57vw',
        },{//遵义
          width:'8vw',
          top:'55vw',
          left:'54vw',
        },{//北京
          width:'10vw',
          top:'27vw',
          left:'67vw',
        },{//丹东
          width:'10vw',
          top:'25vw',
          left:'78vw',
        },{//南京
          width:'12vw',
          top:'42vw',
          left:'72vw',
        },{//武汉
          width:'10vw',
          top:'51vw',
          left:'60vw',
        },{//湘赣边界
          width:'9vw',
          top:'56vw',
          left:'61vw',
        },{//广州
          width:'8vw',
          top:'63vw',
          left:'66vw',
        },{//澳门
          width:'12vw',
          top:'72vw',
          left:'64vw',
        },{//香港
          width:'14vw',
          top:'67vw',
          left:'73vw',
        },{//南昌
          width:'7vw',
          top:'52vw',
          left:'71vw',
        },{//井冈山
          width:'8vw',
          top:'59.5vw',
          left:'72vw',
        },{//古田
          width:'14vw',
          top:'57vw',
          left:'83vw',
        },{//嘉兴
          width:'8vw',
          top:'53vw',
          left:'78vw',
        },{//上海
          width:'15vw',
          top:'47vw',
          left:'83vw',
        }
      ]
    }
  },
  mounted(){
    var video = document.getElementById("audio");
    //console.log(video);
    if (window.WeixinJSBridge) {
      WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
        console.log('111a');
        video.play();
      }, false);
    } else {
      document.addEventListener("WeixinJSBridgeReady", function () {
        WeixinJSBridge.invoke('getNetworkType', {}, function (e) {
          console.log('222a');
          video.play();
        });
      }, false);
    } 
  },
  methods:{
    
  },
}
</script>
<style scoped>
.container{
  background: #e1e1e1;
  min-height: 100vh;
}
.mappic{
  display: block;
  margin: 0 auto;
  width: 90%;
  margin-top: 5vw;
}
.juanzhou{
  width: 100%;
  position: absolute;
  top: 99vw;
  left: 0;
}
.fontpic{
  position: absolute;
  top: 110vw;
  width: 80vw;
  left: 10vw;
}
.picleft{
  width: 17vw;
  position: absolute;
  top: 60vw;
  left: 5vw;
}
.middle{
  position: absolute;
  top: 90vw;
  left: 30vw;
  width: 40vw;
}
.dibiao{
  position: absolute;
  animation: move 2s linear infinite;
}
@keyframes move{
  0%{
    transform: scale(1);
  }
  50%{
    transform: scale(1.2);
  }
  100%{
    transform: scale(1);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mapcom.vue